<template>
  <div>
    <b-row>
      <b-col>
        <b-form-textarea
            id="textarea"
            style="border-radius: 15px; border-color: black;"
            v-model="newSituation"
            placeholder="Dear God ... "
            rows="9"
            max-rows="9"
        />
        <b-button
            class="float-right update-profile-btn"
            style="margin-top: 25px; background-color: #13b7fe; color: black"
            :disabled="!canGenerate"
            @click="handleGenerateClick"
        >
          Send it Up
        </b-button>
      </b-col>
    </b-row>
    <b-row
        v-if="false"
        class="d-none d-sm-block d-md-none"
        style="margin-top: 25px;"
    >
      <b-col>
       &nbsp;
      </b-col>
      <b-col>
        <b-button
            class="float-right update-profile-btn"
            style="margin-top: 25px; background-color: #13b7fe; color: black"
            :disabled="!canGenerate"
            @click="handleGenerateClick"
        >
          Send it Up
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Display_PaneEntry",
  components: {},
  created(){},
  mounted() {},
  props: {
    generating: {
      type: Boolean,
      required: true,
      default: false
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplayActivity: {
      type: Boolean,
      default: false
    },
    myAppSettings_isDisplaySettings: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canGenerate(){
      return this.newSituation && !this.generating ? this.newSituation.length > 0: false;
    }
  },
  methods: {
    handleGenerateClick(){
      if (this.canGenerate){
        this.$emit("generate-click", this.newSituation);
      }
    },
    resetForm() {
        this.newSituation = null;
    }
  },
  data() {
    return {
      newSituation: null
    };
  }
};
</script>

<style lang="scss" scoped>
.update-profile-btn {
  position: absolute;
  right: 5%;
  bottom: 5%;
  text-align: center;
  color: #272f75;
  font-weight: bold;
  cursor: pointer;
  height: 35px;
  width: 135px;
  font-size: 12px;
}
</style>
